import React, { useState } from "react";
import Loader from "../Loader/Loader";
import "./LoginWindow.scss";
import { useHistory } from "react-router-dom";
import {
  CognitoUserAttribute,
  CognitoUser,
  AuthenticationDetails,
  CognitoIdToken,
  CognitoAccessToken,
  CognitoRefreshToken,
  CognitoUserSession,
} from "amazon-cognito-identity-js";
import UserPool from "../../UserPool";
import { Establish_user_session } from "../../Apis/establish_user_session";
import { AddInvestorSessionID } from "../../Apis/AddInvestorSessionID";
import TagManager from "react-gtm-module";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserSubscriptionData } from "../../actions/userSubscriptionActions";
import SocialMediaOAuth from "../SocialMediaOAuth/SocialMediaOAuth";
import { AdvisorExchangeCodeToken } from "../../Apis/AdvisorExchangeCodeToken";
import { redirectUri } from "../SocialMediaOAuth/configAuth";

function LoginWindow({ setScreen, handleOTPConfirmation }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const LoggedIn = () => history.push("/ClientPortfolios");
  const [screenRedirect, setScreenRedirect] = React.useState(null);
  const [isCodeReceived, setIsCodeReceived] = useState(false);

  const popupRedirect = () => {
    if (screenRedirect !== null) {
      var screen = screenRedirect;
      setScreenRedirect(null);
      history.push({
        pathname: screen,
        state: {
          userName: UserName,
          userEmail: "",
        },
      });
    } else {
      setPopupState(false);
    }
  };

  const [selectedAcType, ChangeSelectedAcType] = React.useState("");
  const [UserName, setUserName] = React.useState("");
  const [Password, setPassword] = React.useState("");
  const [WrongUsername, setWrongUsername] = React.useState("");
  const [WrongPassword, setWrongPassword] = React.useState("");
  const [bdopen, setBdOpen] = React.useState(false);
  const [Token, setToken] = React.useState("");
  const [loggedInUser, setLoggedInUser] = React.useState("");
  const [sessionID, setSessionID] = React.useState("");
  const [popupState, setPopupState] = React.useState(false);
  const [popupMessage, setPopupMessage] = React.useState("");
  const [alertType, setAlertType] = React.useState("");
  const [showAgreementPopup, setShowAgreementPopup] = React.useState(false);
  const [AgreementFlag, setAgreementFlag] = React.useState(null);
  const [clientId, setClientId] = React.useState(null);
  const [popupLoginRedierct, setPopupLoginRedirect] = React.useState(false);
  const [AgreementText, setAgreementText] = React.useState("");
  const [subscriptionStatus, setSubscriptionStatus] = React.useState("");
  const [PaymentLinks, setPaymentLinks] = React.useState({});
  var verifyInvestorCount = 0;
  var verifyAdvisorCount = 0;

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    if (code && !isCodeReceived) {
      setBdOpen(true);
      setIsCodeReceived(true);
      AdvisorExchangeCodeToken(code, redirectUri).then((response) => {
        if (response.status === 200 && response.result) {
          const { id_token, access_token, refresh_token } = response.result;
          sessionStorage.setItem("Token", id_token);
          sessionStorage.setItem("access_token", access_token);
          setToken(id_token);
          if (refresh_token)
            sessionStorage.setItem("refresh_token", refresh_token);
          const payload = JSON.parse(atob(id_token.split(".")[1]));
          const username = payload["cognito:username"];
          const email = payload["email"];
          const user = new CognitoUser({
            Username: username,
            Pool: UserPool,
          });

          const userSession = new CognitoUserSession({
            IdToken: new CognitoIdToken({ IdToken: id_token }),
            AccessToken: new CognitoAccessToken({ AccessToken: access_token }),
            RefreshToken: new CognitoRefreshToken({
              RefreshToken: refresh_token || "",
            }),
          });
          user.setSignInUserSession(userSession);
          Establish_user_session(userSession, "advisor");
          setToken(userSession.idToken.jwtToken);
          user.getUserAttributes(async function (err, attributes) {
            if (err) {
              console.error("Error fetching user attributes", err);
            } else {
              try {
                const data = await AddInvestorSessionID();
                console.log("AddInvestorSessionID response:", data);
                if (data === 0 || data === false) {
                  setBdOpen(false);
                  setPopupState(true);
                  setPopupMessage(
                    "Server issue. Please try again or contact support@adaptive-investments.com.",
                  );
                  setAlertType("warning");
                  setPopupLoginRedirect(false);
                  return;
                }
                if (data === 401) {
                  setBdOpen(false);
                  setPopupState(true);
                  setPopupMessage(
                    "Your session timed out for security reasons. Please sign-in again.",
                  );
                  setAlertType("error");
                  setPopupLoginRedirect(true);
                  return;
                }
                if (!data || typeof data !== "object") {
                  setBdOpen(false);
                  setPopupState(true);
                  setPopupMessage(
                    "Unexpected server response. Please try again or contact support@adaptive-investments.com.",
                  );
                  setAlertType("warning");
                  return;
                }

                dispatch(fetchUserSubscriptionData(data));
                sessionStorage.setItem("userType", data["user_type"]);
                sessionStorage.setItem("CustomerID", data["advisor_id"]);
                setClientId(data["advisor_id"]);

                if (data["advisor_id"] !== null) {
                  setBdOpen(false);
                  history.push("/ClientPortfolios");
                }

                TagManager.dataLayer({
                  dataLayer: {
                    event: "UserLogin",
                    userType: data["user_type"],
                    user_id: data["advisor_id"],
                  },
                });
              } catch (e) {
                console.error("AddInvestorSessionID error:", e);
                setBdOpen(false);
                setPopupState(true);
                setPopupMessage(
                  "Server issue. Please try again or contact support@adaptive-investments.com.",
                );
                setAlertType("warning");
                setPopupLoginRedirect(false);
              }
            }
          });
        } else {
          setBdOpen(false);
        }
      });
    }
  }, [isCodeReceived, history, dispatch]);

  React.useEffect(() => {
    window.sessionStorage.setItem("Token", Token);
  }, [Token]);

  React.useEffect(() => {
    window.sessionStorage.setItem("clientId", clientId);
  }, [clientId]);

  React.useEffect(() => {
    window.sessionStorage.setItem("sessionID", sessionID);
  }, [sessionID]);

  const handleBdClose = () => {
    setBdOpen(false);
  };
  const handleBdToggle = () => {
    setBdOpen(!bdopen);
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const [isAccnVisible, setIsAccnVisible] = useState(true);
  const toggleaccount = () => {
    setIsAccnVisible(!isAccnVisible);
  };
  const [isLoginVisible, setIsLoginVisible] = useState(false);
  const togglelogin = () => {
    setIsLoginVisible(!isLoginVisible);
  };

  const verifyInvestorOTP = (user) => {
    if (verifyInvestorCount === 1) {
      verifyInvestorCount = 0;
      setWrongUsername("");
      setWrongPassword("");
      user.resendConfirmationCode(function (err, result) {
        if (err) {
          console.log(err.message || JSON.stringify(err));
        }
        setPopupState(true);
        setPopupMessage(
          "Please verify your account with the Verification code sent to your registered email address. Please check your inbox.",
        );
        var email = user.getUsername();
        handleOTPConfirmation(email);
        setScreen("OTP");
        setAlertType("warning");
        setPopupLoginRedirect(false);
      });
    }
  };

  const verifyAdvisorOTP = (user) => {
    if (verifyAdvisorCount === 1) {
      verifyAdvisorCount = 0;
      setWrongUsername("");
      setWrongPassword("");
      user.resendConfirmationCode(function (err, result) {
        if (err) {
          console.log(err.message || JSON.stringify(err));
        }
        setPopupState(true);
        setScreenRedirect("/OTPConfirmationScreen");
        setPopupMessage(
          "Please verify your account with the Verification code sent to your registered email address. Please check your inbox.",
        );
        setAlertType("warning");
        setPopupLoginRedirect(false);
      });
    }
  };

  const validateLogin = () => {
    let validLoginFlag = true;
    if (!UserName) {
      validLoginFlag = false;
      setWrongUsername("Email cannot be empty.");
    }
    if (
      UserName &&
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(UserName)
    ) {
      validLoginFlag = false;
      setWrongUsername("Invalid Email.");
    }
    if (!Password) {
      validLoginFlag = false;
      setWrongPassword("Password cannot be empty.");
    }
    return validLoginFlag;
  };

  const LogIn = async (event) => {
    if (validateLogin()) {
      handleBdToggle();
      event.preventDefault();
      const user = new CognitoUser({
        Username: UserName.trim().toLowerCase(),
        Pool: UserPool,
      });
      const authDetails = new AuthenticationDetails({
        Username: UserName.trim().toLowerCase(),
        Password: Password,
      });

      user.authenticateUser(authDetails, {
        onSuccess: async (data) => {
          setWrongUsername("");
          setWrongPassword("");
          Establish_user_session(data, selectedAcType);
          const user = UserPool.getCurrentUser();
          if (user === null) {
            console.log("Not Logged In");
          } else {
            var user_name = user.getUsername();
            setLoggedInUser(user_name);
            user.getSession(async function (error, session) {
              if (error) {
                console.log(error);
              }
              if (session) {
                // var session_id = createUserSessionID();
                // setSessionID(session_id);
                setToken(session.idToken.jwtToken);
                sessionStorage.setItem(
                  "access_token",
                  session.getAccessToken().getJwtToken(),
                );
                user.getUserAttributes(async function (err, result) {
                  if (err) {
                    console.log(err);
                  }
                  console.log(" user", user);
                  try {
                    const data = await AddInvestorSessionID();
                    console.log("AddInvestorSessionID response:", data);
                    if (data === 0 || data === false) {
                      setBdOpen(false);
                      setPopupState(true);
                      setPopupMessage(
                        "Server issue. Please try again or contact support@adaptive-investments.com.",
                      );
                      setAlertType("warning");
                      setPopupLoginRedirect(false);
                      return;
                    }
                    if (data === 401) {
                      setBdOpen(false);
                      setPopupState(true);
                      setPopupMessage(
                        "Your session timed out for security reasons. Please sign-in again.",
                      );
                      setAlertType("error");
                      setPopupLoginRedirect(true);
                      return;
                    }
                    if (!data || typeof data !== "object") {
                      setBdOpen(false);
                      setPopupState(true);
                      setPopupMessage(
                        "Unexpected server response. Please try again or contact support@adaptive-investments.com.",
                      );
                      setAlertType("warning");
                      return;
                    }

                    console.log("data logg", data);
                    dispatch(fetchUserSubscriptionData(data));
                    sessionStorage.setItem("userType", data["user_type"]);
                    sessionStorage.setItem("CustomerID", data["advisor_id"]);
                    setClientId(data["advisor_id"]);
                    if (data["advisor_id"] !== null) {
                      setBdOpen(false);
                      LoggedIn();
                    }

                    TagManager.dataLayer({
                      dataLayer: {
                        event: "UserLogin",
                        userType: data["user_type"],
                        user_id: data["advisor_id"],
                      },
                    });
                  } catch (e) {
                    console.error("AddInvestorSessionID error:", e);
                    setBdOpen(false);
                    setPopupState(true);
                    setPopupMessage(
                      "Server issue. Please try again or contact support@adaptive-investments.com.",
                    );
                    setAlertType("warning");
                    setPopupLoginRedirect(false);
                  }
                });
              }
            });
          }
        },

        onFailure: (err) => {
          handleBdClose();
          for (const [key, value] of Object.entries(err)) {
            if (value === "UserNotFoundException") {
              setWrongUsername("Email Id does not exist.");
              setWrongPassword("");
              break;
            }
            if (value === "NotAuthorizedException") {
              if (err.message === "User is disabled.") {
                setWrongUsername(
                  "Your account has been disabled. Please contact support.",
                );
                setWrongPassword("");
              } else {
                setWrongPassword("Incorrect Password.");
                setWrongUsername("");
              }
              break;
            }
            if (
              value === "UserNotConfirmedException" &&
              verifyInvestorCount === 0
            ) {
              verifyInvestorCount = 1;
              sleep(10).then(() => verifyInvestorOTP(user));
              break;
            }
          }
        },

        newPasswordRequired: (data) => {
          handleBdClose();
          console.log("changes password required", data);
        },
      });
    }
  };

  // React.useEffect(() => {
  //   if (clientId && AgreementText && AgreementFlag) {
  //     setShowAgreementPopup(true);
  //   }
  // }, [clientId, AgreementText, AgreementFlag]);

  const handlePopup = () => {
    setPopupState(false);
  };
  return (
    <>
      {bdopen ? (
        <div className="loading-overlay">
          <Loader />
        </div>
      ) : (
        <>
          <div className="ai-login-section">
            <h2>Login</h2>
            <div className="ai-field-group">
              <div className="ai-form-group">
                <label>Email</label>
                <input
                  id="username"
                  className="ai-form-value"
                  type="text"
                  placeholder="Enter Email Id"
                  onChange={(event) => setUserName(event.target.value)}
                />
                <div className="ai-error-message">
                  <p>{WrongUsername}</p>
                </div>
              </div>
              <div className="ai-form-group">
                <label>Password</label>
                <input
                  id="password"
                  className="ai-form-value ai-password"
                  type="password"
                  placeholder="Password"
                  onChange={(event) => setPassword(event.target.value)}
                />
                <div className="ai-error-message">
                  <p>{WrongPassword}</p>
                </div>
              </div>
              <div className="ai-forgot-password">
                <a
                  to="/ForgotPassword"
                  onClick={() => setScreen("Forgot Password")}
                >
                  Forgot Password?
                </a>
              </div>
            </div>
            <div className="ai-field-group">
              <div className="ai-row v-middle">
                <div className="ai-column">
                  <div className="ai-signin">
                    <span>Don’t have an account?</span>
                    <a
                      id="SignUp"
                      className="ai-link"
                      onClick={() => setScreen("Sign Up")}
                    >
                      Sign Up
                    </a>
                  </div>
                </div>
                <button className="ai-btn solid primary round" onClick={LogIn}>
                  <img src="./Assets/next.svg" />
                </button>
              </div>
            </div>
          </div>
          <div className="ai-login-section">
            <div className="ai-field-group">
              <div className="ai-row v-middle">
                <div className="ai-column">
                  <div className="ai-signin">
                    <SocialMediaOAuth
                      providerName="google"
                      action="signin"
                      setBdOpen={setBdOpen}
                    />
                  </div>
                </div>
                <div className="ai-column">
                  <div className="ai-signin">
                    <SocialMediaOAuth
                      providerName="facebook"
                      action="signin"
                      setBdOpen={setBdOpen}
                    />
                  </div>
                </div>
                <div className="ai-column">
                  <div className="ai-signin">
                    <SocialMediaOAuth
                      providerName="linkedin"
                      action="signin"
                      setBdOpen={setBdOpen}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default LoginWindow;
